/**
 * Web Style Import
 *
 */

import './style/dnb-info-card.scss'
